import Vue from 'vue';

import svg_icons from './common/svg_icons.vue';

// SASS/CSS
import '../../css/sass/famiglia.scss';

// images
import '../../images/icons-famiglia.svg';

// disable the warning about dev/prod
Vue.config.productionTip = false;

new Vue({
    el: '#app',

    components: {
        'svg-icons': svg_icons,
        'famiglia-product': () => import(/* webpackChunkName: "famiglia-product" */ './famiglia/product'),
    },
});
